import {
  generationSettings,
  setBatchMode,
  setParallelCount,
  startGenerationBatch,
  type BatchMode,
} from '../generation';

interface TopbarElements {
  countSlider: HTMLInputElement;
  countValue: HTMLElement;
  generateBtn: HTMLButtonElement;
  batchModeBtn: HTMLButtonElement;
}

const SHUFFLE_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 3 21 3 21 8"/><line x1="4" y1="20" x2="21" y2="3"/><polyline points="21 16 21 21 16 21"/><line x1="15" y1="15" x2="21" y2="21"/><line x1="4" y1="4" x2="9" y2="9"/></svg>`;
const ROTATE_SVG = `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 4 23 10 17 10"/><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/></svg>`;

const NEXT_MODE: Record<BatchMode, BatchMode> = {
  off: 'shuffle',
  shuffle: 'rotate',
  rotate: 'off',
};

function renderBatchModeBtn(btn: HTMLButtonElement, mode: BatchMode): void {
  const icon = mode === 'rotate' ? ROTATE_SVG : SHUFFLE_SVG;
  btn.innerHTML = icon;
  btn.classList.toggle('off', mode === 'off');
  btn.classList.toggle('shuffle', mode === 'shuffle');
  btn.classList.toggle('rotate', mode === 'rotate');
  const label =
    mode === 'off'
      ? 'Batch mode: off — use current selections'
      : mode === 'shuffle'
      ? 'Batch mode: shuffle — randomize selections each iteration'
      : 'Batch mode: rotate — cycle through answers each iteration';
  btn.setAttribute('aria-label', label);
  btn.title = label;
}

export function mountTopbar(elements: TopbarElements): void {
  elements.countSlider.value = String(generationSettings.parallelCount);
  elements.countValue.textContent = String(generationSettings.parallelCount);
  renderBatchModeBtn(elements.batchModeBtn, generationSettings.batchMode);

  elements.countSlider.addEventListener('input', () => {
    const value = Number(elements.countSlider.value);
    setParallelCount(value);
    elements.countValue.textContent = String(generationSettings.parallelCount);
  });

  elements.generateBtn.addEventListener('click', () => {
    void startGenerationBatch();
  });

  elements.batchModeBtn.addEventListener('click', () => {
    const next = NEXT_MODE[generationSettings.batchMode];
    setBatchMode(next);
    renderBatchModeBtn(elements.batchModeBtn, next);
  });
}
